export const eventTypeToTitleMap: Record<
  'ticketed' | 'private-dining' | null,
  string
> = {
  'ticketed': 'Ticketed Event',
  'private-dining': 'Private Dining Event',
};
